import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";

const ApprovePortalModel = ({
    show,
    onApproveClick,
    onCloseClick,
    loading,
    selectedUser,
    notes,
    setNotes,
}) => {
    return (
        <Modal isOpen={show} toggle={onCloseClick}>
            <ModalBody className="py-3 px-5">
                <div className="mt-2 text-center">
                    <lord-icon
                        src="https://cdn.lordicon.com/lupuorrc.json"
                        trigger="loop"
                        colors="primary:#00ab55,secondary:#f06548"
                        style={{ width: "100px", height: "100px" }}
                    ></lord-icon>
                    <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                        <h4>Are you sure?</h4>
                        <p className="text-muted mx-4 mb-0">
                            Are you sure you want to
                            {selectedUser?.status === "Approved" ? " unapprove" : " approve"} this
                            user?
                        </p>
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="notes" className="form-label">
                        Notes
                    </label>
                    <textarea
                        type="text"
                        className="form-control"
                        id="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                </div>

                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                    <button
                        type="button"
                        className="btn w-sm btn-light"
                        onClick={onCloseClick}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className={`btn w-sm btn-success ${selectedUser?.status === "Approved" ? "btn-danger" : "btn-success"}`}
                        onClick={onApproveClick}
                        disabled={loading}
                    >
                        Yes, {selectedUser?.status === "Approved" ? "Unapprove" : "Approve"}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ApprovePortalModel;
